import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Grid } from '@mui/material';

const DecisionSummaryHeader = ({ t, decisionSummary }) => (
  <Grid container spacing={1}>
    <Grid item xs={12} md={4}>
      <strong>{t('Document.Decision.Summary.ApprovalLevel')} :</strong> <span>{decisionSummary.approvalLevel}</span>
    </Grid>
    <Grid item xs={12} sm={4}>
      <strong>{t('DocumentEdit.Scoring.ScoringResult.ScoringResult')} : </strong>
      <span>{decisionSummary.scoringResult}</span>
    </Grid>
    <Grid item xs={12} sm={4}>
      <strong> {t('Document.Decision.Summary.FinalDecision')} : </strong>
      <span>{decisionSummary.finalDecision}</span>
    </Grid>
  </Grid>
);

DecisionSummaryHeader.propTypes = {
  t: PropTypes.func.isRequired,
  decisionSummary: PropTypes.object.isRequired
};
export default withTranslation()(DecisionSummaryHeader);
